import { Component, Host, h } from '@stencil/core';

@Component({
  tag: 'nest-segment',
  styleUrl: 'nest-segment.scss',
  shadow: true,
})
export class NestSegment {
  render() {
    return (
      <Host>
        <div
          role="tablist"
          aria-orientation="horizontal"
          tabindex="0"
          data-orientation="horizontal"
          class="inline-flex h-9 items-center justify-center rounded-lg bg-gray-100 p-1 text-muted-foreground outline-none"
        >
          <slot></slot>
        </div>
      </Host>
    );
  }
}
